<template>
  <div id="homePage">

    <accueil-message-important/>

    <!-- <home-news-feed/> -->
    <!-- <h2>En rafale</h2>
    <div class="separateur"></div>
    <home-news type="short"/> -->

    <h2>Nouvelles</h2>
    <div class="separateur"></div>
    <accueil-nouvelles type="nouvelle"/>

    <diaporama-photos/>
    <br/>

    <!-- <h2>Prochaines activités</h2>
    <div class="separateur"></div>
    <liste-activites :limit="5" :show-description="false" :show-calendar="false"/>-->

    <span class="thanks">
      <router-link :to="{ name: 'RemerciementsPage' }">Remerciements/crédits</router-link>
    </span>

  </div>
</template>

<script>
  import DiaporamaPhotos from '../components/Accueil/Diaporama_Photo';
  import AccueilNouvelles from '../components/Accueil/Accueil_Nouvelles';
  //import ListeActivites from '../components/Activites/Activites_Liste';
  import AccueilMessageImportant from '../components/Accueil/Accueil_Message_Important';

  export default {
    name: 'homePage',
    components: {
      AccueilMessageImportant,
      DiaporamaPhotos,
      AccueilNouvelles
    }
  };
</script>

<style lang="scss" scoped>
.layout_droite {
  a {
    font-size: 12px !important;
  }

  p {
    font-size: 12px;
    //margin-bottom: 1.4em;
    padding: 0 30px 20px 30px;
    font-family: Verdana, Arial, Helvetica, sans-serif;
  }
}

.date {
  h3 {
    text-align: right !important;
  }
}

#homePage {
  h2 {
    //padding-left: 15px;
    //font-style: italic;
    font-size: 24px;
    padding-top: 30px;
    text-transform: none;
    color: #385b88;
    font-family: Georgia, "Times New Roman", Times, serif;
    background-image: none;
    border: none;
  }

  .separateur {
    padding-top: 5px;
  }

  h3 {
    text-align: left;
    font-size: 16px;
    font-weight: normal;
    color: #b1661b;
    font-style: normal;
  }
}

.thanks {
  text-align: right;
  float: right;
  margin-top: 40px;
  margin-bottom: 20px;

  a {
    color: gray !important;
    opacity: 0.6;
  }
}
</style>
